import { TerminalsModel } from '../../../src/models/terminals-model'

/** WEATHER ROUTING: */

// message for AlarmType.CounterProposalNotification
export function getCounterProposalAlertTitle(): string {
    const wrRejectInfo = JSON.parse(localStorage.getItem('wrRejected') ?? '{}')
    const departureTerminal =
        TerminalsModel?.getCity(wrRejectInfo.departureTerminalCode) ||
        wrRejectInfo.departureTerminalCode
    const arrivalTerminal =
        TerminalsModel?.getCity(wrRejectInfo.arrivalTerminalCode) ||
        wrRejectInfo.arrivalTerminalCode
    const adviceType = wrRejectInfo?.isWeatherUpdate ? 'Update' : 'Advice'

    return `You have dismissed the Weather ${adviceType} for route ${departureTerminal} to ${arrivalTerminal}, please submit a counter proposal to WNI via planning.`
}
